module.exports = __webpack_public_path__ + "static/media/WoodWorkingProgress1.f4597d08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/zerowaste/WoodWorkingProgress1.jpg
// module id = 210
// module chunks = 0